import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Stack,
  Typography,
  Avatar,
  IconButton,
  Badge,
  Menu,
  MenuItem,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  FaHome,
  FaNewspaper,
  FaCoins,
  FaUser,
  FaGift,
  FaChartBar,
  FaChevronDown,
  FaSignOutAlt,
  FaBars,
  FaTimes,
} from "react-icons/fa";


import { API_URL } from "../config";
import logoImage from "../assets/mainlogo1.png";
import GoldIcon from "../assets/images/gold.png";
import NotiBellImage from "../assets/icons/notibell.jpg";
import ProfileImage from "../assets/images/profile.png";
import { useNotification } from "../notification_context";
import LogoutDialog from "./dialog/logOut";
import { toast } from "react-toastify";

const MainNavbar = () => {
  const navigate = useNavigate();
  const { unreadCount } = useNotification();
  const theme = useTheme();
  
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  // Inside component:
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);
  const [coinNum, setCoinNum] = useState(null);
  const [isOnlineTeacher, setIsOnlineTeacher] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
    const [logoutOpen, setLogoutOpen] = useState(false);
  const menuOpen = Boolean(anchorEl);
  // const navRef = useRef(null);

  const isValidJson = (str) => {
    try {
      JSON.parse(str);
      return true;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const tokenString = localStorage.getItem("authToken");
        if (!tokenString || !isValidJson(tokenString)) {
          navigate("/login");
          return;
        }

        const token = JSON.parse(tokenString);
        const res = await fetch(`${API_URL}/student/profile/`, {
          headers: { Authorization: `Bearer ${token.access}` },
        });

        if (res.ok) {
          const data = await res.json();

          setCoinNum(data.coin_num || 0);
          setIsOnlineTeacher(data.is_onlineT === true);
        } else {
          throw new Error("Failed to fetch profile");
        }
      } catch (err) {
        console.error(err);
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    };

    fetchProfile();
  }, [navigate]);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  
    const handleLogout = () => {
    setLogoutOpen(true);
    handleMenuClose();
  };


    const confirmLogout = () => {
      localStorage.removeItem("authToken");
      toast.success("Logged out successfully!");
      navigate("/login");
    };
  
  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          background: scrolled ? "rgba(255,255,255,0.92)" : "#fff",
          backdropFilter: scrolled ? "blur(16px)" : "none",
          borderBottom: "1px solid",
          borderColor: scrolled ? "rgba(2,136,209,0.12)" : "#f1f5f9",
          boxShadow: scrolled ? "0 2px 20px rgba(2,136,209,0.08)" : "none",
          transition: "all 0.35s ease",
        }}
      >
        <Toolbar
          sx={{
            justifyContent: "space-between",
            minHeight: { xs: 68, md: 72 },
            px: { xs: 2, md: 3 },
          }}
        >
          {/* ── Logo ──────────────────────────────────────────────────── */}
          <Box
            component={Link}
            to="/"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              textDecoration: "none",
            }}
          >
            <img
              src={logoImage}
              alt="LiteUpper"
              style={{ height: 40, borderRadius: 10, display: "block" }}
            />
            <Box sx={{ display: { xs: "none", sm: "block" } }}>
              <Typography
                sx={{
                  fontWeight: 900,
                  fontSize: "1.15rem",
                  letterSpacing: "-0.5px",
                  lineHeight: 1,
                  background: "linear-gradient(90deg, #0288D1, #7c3aed)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                LiteUpper
              </Typography>
              <Typography
                sx={{
                  fontSize: "0.52rem",
                  fontWeight: 700,
                  color: "#94a3b8",
                  textTransform: "uppercase",
                  letterSpacing: "0.8px",
                  lineHeight: 1,
                }}
              >
                Exam Prep Platform
              </Typography>
            </Box>
          </Box>

          {/* ── Desktop Nav ───────────────────────────────────────────── */}
          {!isMobile ? (
            <Stack direction="row" alignItems="center" spacing={0.5}>
              {/* Nav links */}
              {[
                { label: "Home", icon: <FaHome size={13} />, path: "/home" },
                {
                  label: "News",
                  icon: <FaNewspaper size={13} />,
                  path: "/news",
                },
              ].map((item) => (
                <Box
                  key={item.label}
                  component={Link}
                  to={item.path}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.75,
                    px: 2,
                    py: 1,
                    borderRadius: 2,
                    textDecoration: "none",
                    fontWeight: 600,
                    fontSize: "0.85rem",
                    color: "#334155",
                    transition: "all 0.2s",
                    "&:hover": {
                      color: "#0288D1",
                      background: "rgba(2,136,209,0.06)",
                    },
                  }}
                >
                  <Box sx={{ color: "inherit", display: "flex" }}>
                    {item.icon}
                  </Box>
                  {item.label}
                </Box>
              ))}

              {/* Divider */}
              <Box
                sx={{ width: 1, height: 24, background: "#e2e8f0", mx: 0.5 }}
              />

              {/* Coins badge */}
              <Box
                onClick={() => navigate("/golds")}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2,
                  py: 0.9,
                  borderRadius: 99,
                  background:
                    "linear-gradient(135deg, rgba(245,158,11,0.1), rgba(251,191,36,0.08))",
                  border: "1px solid rgba(245,158,11,0.25)",
                  cursor: "pointer",
                  transition: "all 0.2s",
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, rgba(245,158,11,0.18), rgba(251,191,36,0.14))",
                    transform: "translateY(-1px)",
                  },
                }}
              >
                <img
                  src={GoldIcon}
                  alt="Coins"
                  style={{ width: 18, height: 18 }}
                />
                <Typography
                  sx={{
                    fontWeight: 800,
                    fontSize: "0.82rem",
                    color: "#d97706",
                  }}
                >
                  {coinNum !== null ? coinNum.toLocaleString() : "…"}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.68rem",
                    fontWeight: 600,
                    color: "#f59e0b",
                  }}
                >
                  Coins
                </Typography>
              </Box>

              {/* Notifications */}
              <Tooltip title="Notifications" arrow>
                <IconButton
                  onClick={() => navigate("/notifications")}
                  sx={{
                    position: "relative",
                    color: "#64748b",
                    background: "rgba(2,136,209,0.05)",
                    border: "1px solid rgba(2,136,209,0.12)",
                    borderRadius: 2,
                    "&:hover": {
                      background: "rgba(2,136,209,0.1)",
                      color: "#0288D1",
                    },
                    transition: "all 0.2s",
                  }}
                >
                  <Badge
                    badgeContent={unreadCount}
                    color="error"
                    sx={{
                      "& .MuiBadge-badge": {
                        fontSize: "0.6rem",
                        minWidth: 16,
                        height: 16,
                        p: 0,
                      },
                    }}
                  >
                    <img
                      src={NotiBellImage}
                      alt="Notifications"
                      style={{ width: 20, height: 20 }}
                    />
                  </Badge>
                </IconButton>
              </Tooltip>

              {/* Profile avatar */}
              <Box
                onClick={handleMenuOpen}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  pl: 1,
                  pr: 1.5,
                  py: 0.6,
                  borderRadius: 99,
                  border: "1px solid rgba(2,136,209,0.15)",
                  background: "rgba(2,136,209,0.04)",
                  cursor: "pointer",
                  transition: "all 0.2s",
                  "&:hover": {
                    background: "rgba(2,136,209,0.1)",
                    borderColor: "rgba(2,136,209,0.3)",
                  },
                }}
              >
                <Avatar
                  src={ProfileImage}
                  sx={{
                    width: 32,
                    height: 32,
                    border: "2px solid rgba(2,136,209,0.3)",
                    background: "linear-gradient(135deg, #0288D1, #0ea5e9)",
                    fontSize: "0.8rem",
                    fontWeight: 800,
                  }}
                />
                <FaChevronDown size={10} color="#64748b" />
              </Box>

              {/* Profile dropdown */}
              <Menu
                anchorEl={anchorEl}
                open={menuOpen && !isMobile}
                onClose={handleMenuClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    mt: 1.5,
                    minWidth: 220,
                    borderRadius: 2.5,
                    border: "1px solid rgba(2,136,209,0.15)",
                    boxShadow: "0 8px 32px rgba(2,136,209,0.12)",
                    overflow: "hidden",
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                {/* Menu header */}
                <Box
                  sx={{
                    px: 2.5,
                    py: 2,
                    borderBottom: "1px solid #f1f5f9",
                    background:
                      "linear-gradient(135deg, rgba(2,136,209,0.05), rgba(14,165,233,0.03))",
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={1.5}>
                    <Avatar
                      src={ProfileImage}
                      sx={{
                        width: 36,
                        height: 36,
                        border: "2px solid rgba(2,136,209,0.2)",
                        background: "linear-gradient(135deg, #0288D1, #0ea5e9)",
                        fontSize: "0.9rem",
                        fontWeight: 800,
                      }}
                    />
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: 800,
                          color: "#0c1a2e",
                          fontSize: "0.88rem",
                        }}
                      >
                        My Account
                      </Typography>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                      >
                        <FaCoins size={10} color="#f59e0b" />
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#d97706",
                            fontWeight: 700,
                          }}
                        >
                          {coinNum !== null ? coinNum.toLocaleString() : "…"}{" "}
                          Coins
                        </Typography>
                      </Box>
                    </Box>
                  </Stack>
                </Box>
                {/* Desktop menu items */}
                    {[
                      {
                        label: "My Profile",
                        icon: <FaUser size={12} />,
                        path: "/profile",
                        color: "#0288D1",
                      },
                      {
                        label: "My Coins",
                        icon: <FaCoins size={12} />,
                        path: "/golds",
                        color: "#d97706",
                      },
                      {
                        label: "Referrals",
                        icon: <FaGift size={12} />,
                        path: "/referral",
                        color: "#7c3aed",
                      },

                      ...(isOnlineTeacher
                        ? [
                            {
                              label: "My Stats",
                              icon: <FaChartBar size={12} />,
                              path: "/teacher/video-stats",
                              color: "#059669",
                            },
                          ]
                        : []),
                    ].map((item) => (
                  <MenuItem
                    key={item.label}
                    onClick={() => {
                      handleMenuClose();
                      navigate(item.path);
                    }}
                    sx={{
                      px: 2.5,
                      py: 1.5,
                      gap: 1.5,
                      fontSize: "0.88rem",
                      fontWeight: 600,
                      color: "#334155",
                      transition: "all 0.15s",
                      "&:hover": {
                        background: "rgba(2,136,209,0.05)",
                        color: "#0288D1",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: 26,
                        height: 26,
                        borderRadius: 1.5,
                        background: `${item.color}14`,
                        border: `1px solid ${item.color}28`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: item.color,
                        flexShrink: 0,
                      }}
                    >
                      {item.icon}
                    </Box>
                    {item.label}
                  </MenuItem>
                ))}

                <Box
                  sx={{ height: 1, background: "#f1f5f9", mx: 2, my: 0.5 }}
                />

                <MenuItem
                  onClick={handleLogout}
                  sx={{
                    px: 2.5,
                    py: 1.5,
                    gap: 1.5,
                    fontSize: "0.88rem",
                    fontWeight: 700,
                    color: "#ef4444",
                    "&:hover": { background: "rgba(239,68,68,0.05)" },
                  }}
                >
                  <Box
                    sx={{
                      width: 26,
                      height: 26,
                      borderRadius: 1.5,
                      background: "rgba(239,68,68,0.08)",
                      border: "1px solid rgba(239,68,68,0.15)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <FaSignOutAlt size={12} color="#ef4444" />
                  </Box>
                  Logout
                </MenuItem>
              </Menu>
            </Stack>
          ) : (
            /* ── Mobile hamburger ─────────────────────────────────────── */
            <Stack direction="row" alignItems="center" spacing={1}>
              <Tooltip title="Notifications" arrow>
                <IconButton
                  onClick={() => navigate("/notifications")}
                  sx={{
                    color: "#64748b",
                    background: "rgba(2,136,209,0.05)",
                    border: "1px solid rgba(2,136,209,0.12)",
                    borderRadius: 2,
                    "&:hover": { background: "rgba(2,136,209,0.1)" },
                  }}
                >
                  <Badge
                    badgeContent={unreadCount}
                    color="error"
                    sx={{
                      "& .MuiBadge-badge": {
                        fontSize: "0.6rem",
                        minWidth: 16,
                        height: 16,
                      },
                    }}
                  >
                    <img
                      src={NotiBellImage}
                      alt="Notifications"
                      style={{ width: 18, height: 18 }}
                    />
                  </Badge>
                </IconButton>
              </Tooltip>

              <IconButton
                onClick={handleMenuOpen}
                sx={{
                  color: "#0c1a2e",
                  background: "rgba(2,136,209,0.06)",
                  border: "1px solid rgba(2,136,209,0.15)",
                  borderRadius: 2,
                  "&:hover": { background: "rgba(2,136,209,0.12)" },
                }}
              >
                {menuOpen ? <FaTimes size={18} /> : <FaBars size={18} />}
              </IconButton>
            </Stack>
          )}
        </Toolbar>
      </AppBar>

      {/* ── Mobile Drawer Menu ───────────────────────────────────────────── */}
      <Menu
        anchorEl={anchorEl}
        open={menuOpen && isMobile}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
       PaperProps={{
          elevation: 0,
          sx: {
            mt: 1,
            width: "calc(100vw - 24px)",
            maxWidth: 340,
            maxHeight: "calc(100dvh - 90px)",
            overflowY: "auto",
            overflowX: "hidden",
            overscrollBehavior: "contain",
            WebkitOverflowScrolling: "touch",
            borderRadius: 2.5,
            border: "1px solid rgba(2,136,209,0.15)",
            boxShadow: "0 12px 40px rgba(2,136,209,0.15)",

            "&::-webkit-scrollbar": {
              width: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#cbd5e1",
              borderRadius: "10px",
            },
          },
        }}
      >
        {/* Mobile menu header */}
        <Box
          sx={{
            px: 2.5,
            py: 2.5,
            borderBottom: "1px solid #f1f5f9",
            background:
              "linear-gradient(135deg, rgba(2,136,209,0.06), rgba(14,165,233,0.03))",
          }}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <Avatar
              src={ProfileImage}
              sx={{
                width: 48,
                height: 48,
                border: "2px solid rgba(2,136,209,0.25)",
                background: "linear-gradient(135deg, #0288D1, #0ea5e9)",
                fontWeight: 800,
              }}
            />
            <Box>
              <Typography
                sx={{ fontWeight: 800, color: "#0c1a2e", fontSize: "0.95rem" }}
              >
                Welcome back!
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.6,
                  mt: 0.25,
                }}
              >
                <FaCoins size={11} color="#f59e0b" />
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    color: "#d97706",
                    fontWeight: 700,
                  }}
                >
                  {coinNum !== null
                    ? `${coinNum.toLocaleString()} Coins`
                    : "Loading…"}
                </Typography>
              </Box>
            </Box>
          </Stack>
        </Box>

        {/* Mobile menu items */}
          {[
            {
              label: "Home",
              icon: <FaHome size={13} />,
              path: "/home",
              color: "#0288D1",
            },
            {
              label: "News",
              icon: <FaNewspaper size={13} />,
              path: "/news",
              color: "#0288D1",
            },
            {
              label: "My Coins",
              icon: <FaCoins size={13} />,
              path: "/golds",
              color: "#d97706",
            },
            {
              label: "Profile",
              icon: <FaUser size={13} />,
              path: "/profile",
              color: "#7c3aed",
            },
            {
              label: "Referrals",
              icon: <FaGift size={13} />,
              path: "/referral",
              color: "#059669",
            },

            ...(isOnlineTeacher
              ? [
                  {
                    label: "My Stats",
                    icon: <FaChartBar size={13} />,
                    path: "/teacher/video-stats",
                    color: "#059669",
                  },
                ]
              : []),
          ].map((item) => (
          <MenuItem
            key={item.label}
            onClick={() => {
              handleMenuClose();
              navigate(item.path);
            }}
            sx={{
              px: 2.5,
              py: 1.6,
              gap: 1.5,
              fontSize: "0.9rem",
              fontWeight: 600,
              color: "#334155",
              transition: "all 0.15s",
              "&:hover": {
                background: "rgba(2,136,209,0.05)",
                color: "#0288D1",
              },
            }}
          >
            <Box
              sx={{
                width: 30,
                height: 30,
                borderRadius: 1.5,
                background: `${item.color}12`,
                border: `1px solid ${item.color}25`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: item.color,
                flexShrink: 0,
              }}
            >
              {item.icon}
            </Box>
            {item.label}
          </MenuItem>
        ))}

        <Box sx={{ height: 1, background: "#f1f5f9", mx: 2, my: 0.5 }} />

        <MenuItem
          onClick={handleLogout}
          sx={{
            px: 2.5,
            py: 1.6,
            gap: 1.5,
            fontSize: "0.9rem",
            fontWeight: 700,
            color: "#ef4444",
            "&:hover": { background: "rgba(239,68,68,0.05)" },
            mb: 0.5,
          }}
        >
          <Box
            sx={{
              width: 30,
              height: 30,
              borderRadius: 1.5,
              background: "rgba(239,68,68,0.08)",
              border: "1px solid rgba(239,68,68,0.15)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <FaSignOutAlt size={13} color="#ef4444" />
          </Box>
          Logout
        </MenuItem>
      </Menu>

      {/* Logout Confirmation Dialog */}
      <LogoutDialog
        open={logoutOpen}
        onClose={() => setLogoutOpen(false)}
        onConfirm={confirmLogout}
      />
    </>
  );
};

export default MainNavbar;
